import React from 'react';
import { HomeIcon, ShoppingBagIcon, SearchIcon, ShoppingCartIcon, UserIcon } from 'lucide-react';
interface MobileBottomNavProps {
  currentPage: 'home' | 'shop' | 'product';
  onNavigate: (page: 'home' | 'shop' | 'product') => void;
  onOpenCart: () => void;
}
export function MobileBottomNav({
  currentPage,
  onNavigate,
  onOpenCart
}: MobileBottomNavProps) {
  const navItems = [{
    id: 'home' as const,
    label: 'Home',
    icon: HomeIcon
  }, {
    id: 'shop' as const,
    label: 'Shop',
    icon: ShoppingBagIcon
  }, {
    id: 'search' as const,
    label: 'Search',
    icon: SearchIcon
  }, {
    id: 'cart' as const,
    label: 'Cart',
    icon: ShoppingCartIcon
  }, {
    id: 'account' as const,
    label: 'Account',
    icon: UserIcon
  }];
  const handleNavClick = (id: string) => {
    if (id === 'cart') {
      onOpenCart();
    } else if (id === 'search') {
      // Search would open a search modal/page in a real app
      return;
    } else if (id === 'account') {
      // Account would navigate to account page
      return;
    } else {
      onNavigate(id as 'home' | 'shop');
    }
  };
  return <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-2px_10px_rgba(0,0,0,0.06)] pb-safe" data-id="element-510">
      <div className="grid grid-cols-5 h-14" data-id="element-511">
        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = item.id === currentPage;
        return <button key={item.id} onClick={() => handleNavClick(item.id)} className={`flex flex-col items-center justify-center gap-1 transition-colors active:scale-95 ${isActive ? 'text-brand-blue' : 'text-gray-500 active:text-brand-blue'}`} aria-label={item.label} data-id="element-512">
              <Icon className={`w-6 h-6 ${isActive ? 'stroke-[2.5]' : 'stroke-2'}`} data-id="element-513" />
              <span className={`text-[10px] font-medium ${isActive ? 'font-bold' : ''}`} data-id="element-514">
                {item.label}
              </span>
            </button>;
      })}
      </div>
    </nav>;
}